<template>
	<svg id="Badge" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300">
		<path
			fill="#7314ef"
			d="M300,33.22V266.78A33.22,33.22,0,0,1,266.78,300H33.22A33.22,33.22,0,0,1,0,266.78V33.22A33.22,33.22,0,0,1,33.22,0H266.78a33.13,33.13,0,0,1,17.43,4.93,33.61,33.61,0,0,1,7.44,6.26A33.11,33.11,0,0,1,300,33.22Z"
		/>
		<path fill="#f730d0" d="M148.33,300H33.22A33.22,33.22,0,0,1,0,266.78V147.71A279,279,0,0,1,148.33,300Z" />
		<circle fill="#490ca2" cx="24.39" cy="240.67" r="16.78" />
		<path fill="#490ca2" d="M83.83,300H50.66a16.78,16.78,0,0,1,33.17,0Z" />
		<path
			fill="#e9b346"
			d="M300,33.22V134.11A165.85,165.85,0,0,1,249.16,142,166.38,166.38,0,0,1,84.59,0H266.78a33.13,33.13,0,0,1,17.43,4.93,33.61,33.61,0,0,1,7.44,6.26A33.11,33.11,0,0,1,300,33.22Z"
		/>
		<path
			fill="#7314ef"
			d="M300,33.22v91.61a156.8,156.8,0,0,1-51.29,8.57A157.3,157.3,0,0,1,93.27,0H266.78a33.13,33.13,0,0,1,17.43,4.93,33.61,33.61,0,0,1,7.44,6.26A33.11,33.11,0,0,1,300,33.22Z"
		/>
		<path
			fill="#e9b346"
			d="M300,33.22V91.58a125.89,125.89,0,0,1-51.29,10.86A126.33,126.33,0,0,1,124.68,0h142.1a33.13,33.13,0,0,1,17.43,4.93,33.61,33.61,0,0,1,7.44,6.26A33.11,33.11,0,0,1,300,33.22Z"
		/>
		<path
			fill="#7314ef"
			d="M300,33.22V81.53a116.82,116.82,0,0,1-50.84,11.55A117.41,117.41,0,0,1,134.3,0H266.78a33.13,33.13,0,0,1,17.43,4.93,33.61,33.61,0,0,1,7.44,6.26A33.11,33.11,0,0,1,300,33.22Z"
		/>
		<path
			fill="#e9b346"
			d="M300,33.22V52.43a91.59,91.59,0,0,1-50.84,15.28A92.06,92.06,0,0,1,160.42,0H266.78a33.13,33.13,0,0,1,17.43,4.93,33.61,33.61,0,0,1,7.44,6.26A33.11,33.11,0,0,1,300,33.22Z"
		/>
		<path
			fill="#7314ef"
			d="M300,33.22v7.87a82.43,82.43,0,0,1-50.84,17.44A82.85,82.85,0,0,1,170,0h96.82a33.13,33.13,0,0,1,17.43,4.93,33.61,33.61,0,0,1,7.44,6.26A33.11,33.11,0,0,1,300,33.22Z"
		/>
		<path
			fill="#e9b346"
			d="M291.65,11.19a55.56,55.56,0,0,1-42.94,20.26A55.63,55.63,0,0,1,198.6,0h68.18a33.13,33.13,0,0,1,17.43,4.93A33.61,33.61,0,0,1,291.65,11.19Z"
		/>
		<path
			fill="#7314ef"
			d="M284.21,4.93a45.52,45.52,0,0,1-35,16.4A45.58,45.58,0,0,1,210.53,0h56.25A33.13,33.13,0,0,1,284.21,4.93Z"
		/>
	</svg>
</template>
